import type { FC } from "react";
import { Fragment } from "react";
import Markdown from "react-markdown";
import { Prism as SyntaxHighlighter } from "react-syntax-highlighter";
import { styled } from "@mui/material/styles";
import rehypeRaw from "rehype-raw";
import remarkGfm from "remark-gfm";
import { codeStyle } from "src/utils/code-style";
import { Components, PluggableList } from "react-markdown/lib";
import {
  BLOG_CONTACT_FOOTER_MARKER,
  BlogContactFooter,
} from "src/sections/dashboard/blog/blog-contact-footer";

const Code: Components["code"] = (props: any) => {
  const { node, inline, className, children, ...other } = props;

  const language = /language-(\w+)/.exec(className || "");

  return !inline && language ? (
    // <SyntaxHighlighter
    //   children={String(children).replace(/\n$/, '')}
    //   language={language[1]}
    //   PreTag="div"
    //   style={codeStyle}
    //   {...other}
    // />
    <></>
  ) : (
    <code className={className} {...other}>
      {children}
    </code>
  );
};

const components = {
  code: Code,
};

const PostContentRoot = styled("div")(({ theme }) => ({
  color: theme.palette.text.primary,
  fontFamily: theme.typography.fontFamily,
  "& code": {
    color: theme.palette.primary.main,
    fontFamily:
      "Inconsolata, Monaco, Consolas, 'Courier New', Courier, monospace",
    fontSize: 14,
    padding: "2px 4px",
    backgroundColor: theme.palette.action.hover,
    borderRadius: 4,
  },
  "& h2": {
    fontSize: theme.typography.h5.fontSize,
    fontWeight: theme.typography.fontWeightBold,
    lineHeight: theme.typography.h5.lineHeight,
    marginBottom: theme.spacing(3),
  },
  "& h3": {
    fontSize: theme.typography.h3.fontSize,
    fontWeight: theme.typography.fontWeightBold,
    lineHeight: theme.typography.h3.lineHeight,
    marginBottom: theme.spacing(3),
  },
  "& p": {
    fontSize: theme.typography.body1.fontSize,
    lineHeight: theme.typography.body1.lineHeight,
    marginBottom: theme.spacing(2),
  },
  "& li": {
    fontSize: theme.typography.body1.fontSize,
    lineHeight: theme.typography.body1.lineHeight,
    marginBottom: theme.spacing(1),
  },
  "& img": {
    maxWidth: "100%",
    height: "auto",
    display: "block",
    marginLeft: "auto",
    marginRight: "auto",
  },
}));

interface PostContentProps {
  content: string;
}

export const PostContent: FC<PostContentProps> = (props) => {
  const { content } = props;
  const parts = content.split(BLOG_CONTACT_FOOTER_MARKER);

  return (
    <PostContentRoot>
      {parts.map((part, index) => (
        <Fragment key={index}>
          {part.trim() ? (
            <Markdown
              children={part}
              components={components}
              remarkPlugins={[remarkGfm]}
              rehypePlugins={[rehypeRaw] as PluggableList}
            />
          ) : null}
          {index < parts.length - 1 ? <BlogContactFooter /> : null}
        </Fragment>
      ))}
    </PostContentRoot>
  );
};
